import { withTrendingSectionProps } from 'viewModel/gallery/withTrendingSectionProps';
import TrendingSection from 'components/Community/TrendingSection/TrendingSection';

export default withTrendingSectionProps(TrendingSection);
